// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <template v-for="(s, i) in item">
          <p class="title" :key="i">{{ s }}</p>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

export default {
  name: 'license-status',

  props: {
    value: this.value
  },

  data () {
    return {
      item: this.value
    }
  },

  watch: {
    value: function () {
      this.item = this.value
    },

    item: function () {
      this.$emit('input', this.item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tabs/LicenseStatus.vue